(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pk-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-bundle-builder')) {
    customElements.define('pk-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        this.max = parseInt(this.getAttribute('max') || '3', 10);
        this.items = Array.from(this.querySelectorAll('.pk-bb__item'));
        this.steps = Array.from(this.querySelectorAll('.pk-bb__step'));
        this.countEl = this.querySelector('[data-pk-count]');
        this.pickedEl = this.querySelector('[data-pk-picked]');
        this.totalEl = this.querySelector('[data-pk-total]');
        this.addBtn = this.querySelector('[data-pk-add]');
        this.errorEl = this.querySelector('[data-pk-error]');
        this.countTemplate = this.countEl ? this.countEl.textContent : '';
        this.selected = new Map();
        this.items.forEach((item) => item.addEventListener('click', () => this.toggle(item)));
        if (this.addBtn) this.addBtn.addEventListener('click', () => this.addToCart());
        this.render();
      }

      toggle(item) {
        const id = item.dataset.variant;
        if (this.selected.has(id)) {
          this.selected.delete(id);
          item.setAttribute('aria-pressed', 'false');
        } else {
          if (this.selected.size >= this.max) return;
          this.selected.set(id, { title: item.dataset.title, price: parseInt(item.dataset.price, 10) || 0 });
          item.setAttribute('aria-pressed', 'true');
        }
        this.render();
      }

      formatMoney(cents) {
        const open = '\\{\\{\\s*';
        const close = '\\s*\\}\\}';
        const tag = (key) => new RegExp(open + key + close);
        const format = this.getAttribute('money-format') || ('$' + '{' + '{amount}' + '}');
        const amount = (cents / 100).toFixed(2);
        const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const whole = Math.round(cents / 100).toString();
        return format
          .replace(tag('amount_no_decimals_with_comma_separator'), whole)
          .replace(tag('amount_with_comma_separator'), amount.replace('.', ','))
          .replace(tag('amount_no_decimals'), whole)
          .replace(tag('amount'), withCommas)
          .replace(/<[^>]*>/g, '');
      }

      render() {
        const count = this.selected.size;
        const full = count >= this.max;
        this.items.forEach((item) => { item.disabled = full && !this.selected.has(item.dataset.variant); });
        this.steps.forEach((step) => { step.classList.toggle('is-done', parseInt(step.dataset.step, 10) <= count); });
        if (this.countEl) this.countEl.textContent = this.countTemplate.replace(/\[n\]|\b0\b/, String(count));
        if (this.pickedEl) this.pickedEl.textContent = Array.from(this.selected.values()).map((v) => v.title).join(' · ');
        let total = 0;
        this.selected.forEach((entry) => { total += entry.price; });
        if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);
        if (this.addBtn) this.addBtn.disabled = count === 0;
        if (this.errorEl) this.errorEl.hidden = true;
      }

      async addToCart() {
        if (this.selected.size === 0) return;
        const items = Array.from(this.selected.keys()).map((id) => ({ id: parseInt(id, 10), quantity: 1 }));
        this.addBtn.classList.add('is-loading');
        try {
          const response = await fetch(this.getAttribute('add-url') || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(body.description || body.message || 'Could not add the bundle.');
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            setTimeout(() => drawer.show(), 400);
          } else {
            window.location.href = this.getAttribute('cart-url') || '/cart';
          }
        } catch (error) {
          if (this.errorEl) { this.errorEl.textContent = error.message; this.errorEl.hidden = false; }
        } finally {
          this.addBtn.classList.remove('is-loading');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-comparison-matrix"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-comparison-matrix')) {
    customElements.define('pk-comparison-matrix', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-pk-toggle]').forEach((input) => {
          input.addEventListener('change', () => this.toggleColumn(input.dataset.pkToggle, input.checked));
        });
      }

      toggleColumn(id, visible) {
        const checked = Array.from(this.querySelectorAll('[data-pk-toggle]')).filter((i) => i.checked);
        if (!visible && checked.length === 0) {
          const input = this.querySelector('[data-pk-toggle="' + id + '"]');
          if (input) input.checked = true;
          return;
        }
        this.querySelectorAll('[data-pk-col="' + id + '"]').forEach((cell) => { cell.hidden = !visible; });
        this.style.setProperty('--pk-cols', checked.length);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-find-your-function"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-function-matrix')) {
    customElements.define('pk-function-matrix', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      onKeydown(event, index) {
        let next = null;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        const target = (next + this.tabs.length) % this.tabs.length;
        this.select(target);
        this.tabs[target].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active) {
            const wrap = tab.closest('.pk-tabs-wrap');
            if (wrap) wrap.scrollTo({ left: Math.max(0, tab.offsetLeft - (wrap.clientWidth - tab.offsetWidth) / 2), behavior: 'smooth' });
          }
        });
        this.panels.forEach((panel, i) => {
          if (i === index) {
            panel.hidden = false;
            requestAnimationFrame(() => panel.classList.add('is-active'));
          } else {
            panel.classList.remove('is-active');
            panel.hidden = true;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-function-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-function-nav')) {
    customElements.define('pk-function-nav', class extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('.pk-fnav__switch-btn'));
        this.groups = Array.from(this.querySelectorAll('.pk-fnav__group'));
        this.markCurrent();

        let view = this.getAttribute('default-view');
        if (this.getAttribute('remember') === 'true') {
          try {
            const saved = window.sessionStorage.getItem('pk-fnav-view');
            if (saved && this.groups.some((g) => g.dataset.view === saved)) view = saved;
          } catch (error) {}
        }
        const current = this.querySelector('.pk-fnav__pill[aria-current="page"]');
        if (current) {
          const group = current.closest('.pk-fnav__group');
          if (group) view = group.dataset.view;
        }
        this.show(view, false);

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.show(button.dataset.view, true));
        });
      }

      show(view, persist) {
        if (!this.groups.some((g) => g.dataset.view === view)) return;
        this.groups.forEach((group) => { group.hidden = group.dataset.view !== view; });
        this.buttons.forEach((button) => {
          button.setAttribute('aria-selected', button.dataset.view === view ? 'true' : 'false');
        });
        if (persist && this.getAttribute('remember') === 'true') {
          try { window.sessionStorage.setItem('pk-fnav-view', view); } catch (error) {}
        }
      }

      markCurrent() {
        const here = new URL(window.location.href);
        this.querySelectorAll('.pk-fnav__pill').forEach((pill) => {
          let target;
          try { target = new URL(pill.getAttribute('href'), window.location.origin); } catch (error) { return; }
          if (target.pathname.replace(/\/$/, '') !== here.pathname.replace(/\/$/, '')) return;
          const params = Array.from(target.searchParams.entries());
          const matches = params.every(([key, value]) => here.searchParams.getAll(key).includes(value));
          if (!matches) return;
          if (params.length === 0 && Array.from(here.searchParams.keys()).some((k) => k.startsWith('filter.'))) return;
          pill.setAttribute('aria-current', 'page');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-ingredient-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-ingredient-explorer')) {
    customElements.define('pk-ingredient-explorer', class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-pk-product]'));
        this.chipList = this.querySelector('[data-pk-chips]');
        this.detail = this.querySelector('[data-pk-detail]');
        this.idle = this.querySelector('[data-pk-idle]');
        this.allChips = this.querySelector('[data-pk-all-chips]');
        this.active = null;

        const index = new Map();
        this.querySelectorAll('[data-pk-ingredient]').forEach((item) => {
          const raw = (item.dataset.pkIngredient || '').trim();
          const key = this.normalize(raw);
          if (!key) return;
          item.dataset.pkKey = key;
          const entry = index.get(key) || { name: this.displayName(raw), count: 0, purpose: '', products: new Set() };
          const card = item.closest('[data-pk-product]');
          if (card) entry.products.add(card.dataset.pkProduct);
          entry.count = entry.products.size;
          if (!entry.purpose && item.dataset.pkPurpose) entry.purpose = item.dataset.pkPurpose;
          if (this.displayName(raw).length < entry.name.length) entry.name = this.displayName(raw);
          index.set(key, entry);
        });

        this.cards.forEach((card) => {
          card.dataset.pkKeys = Array.from(card.querySelectorAll('[data-pk-ingredient]')).map((li) => li.dataset.pkKey).join('|');
          const more = card.querySelector('[data-pk-more]');
          if (more) {
            more.addEventListener('click', () => {
              card.querySelectorAll('[data-pk-overflow]').forEach((li) => { li.hidden = false; });
              more.setAttribute('aria-expanded', 'true');
              more.hidden = true;
            });
          }
        });

        let rare = 0;
        Array.from(index.entries())
          .sort((a, b) => b[1].count - a[1].count || a[1].name.localeCompare(b[1].name))
          .forEach(([key, entry]) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'pk-chip pk-chip--button';
            button.dataset.key = key;
            button.setAttribute('aria-pressed', 'false');
            const label = document.createElement('span');
            label.textContent = entry.name;
            const count = document.createElement('span');
            count.className = 'pk-chip__dose';
            count.textContent = String(entry.count);
            button.append(label, count);
            if (entry.count < 2) { button.dataset.pkRare = ''; button.hidden = true; rare += 1; }
            button.addEventListener('click', () => this.select(this.active === key ? null : key, entry));
            this.chipList.appendChild(button);
          });

        if (this.allChips && rare > 0 && index.size - rare > 0) {
          this.allChips.hidden = false;
          this.allChips.textContent = this.allChips.textContent.replace('[n]', String(rare));
          this.allChips.addEventListener('click', () => {
            this.chipList.querySelectorAll('[data-pk-rare]').forEach((chip) => { chip.hidden = false; });
            this.allChips.setAttribute('aria-expanded', 'true');
            this.allChips.hidden = true;
          });
        } else if (rare > 0) {
          this.chipList.querySelectorAll('[data-pk-rare]').forEach((chip) => { chip.hidden = false; });
        }
      }

      normalize(name) {
        return name.toLowerCase()
          .replace(/[®™]/g, '')
          .replace(/\([^)]*\)/g, ' ')
          .replace(/\s[—–-]\s.*$/, ' ')
          .replace(/\b(extract|root|powder|leaf|leaves|seed|whole plant|fruiting body|from)\b/g, ' ')
          .replace(/[^a-z0-9'\s]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      displayName(name) {
        return name.replace(/\s*\([^)]*\)/g, '').replace(/\s[—–-]\s.*$/, '').replace(/\s+/g, ' ').trim();
      }

      select(key, entry) {
        this.active = key;
        this.querySelectorAll('[data-key]').forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.key === key ? 'true' : 'false');
        });
        let shown = 0;
        this.cards.forEach((card) => {
          const keys = (card.dataset.pkKeys || '').split('|');
          const visible = !key || keys.includes(key);
          card.hidden = !visible;
          if (visible) shown += 1;
          card.querySelectorAll('[data-pk-ingredient]').forEach((item) => {
            const hit = Boolean(key) && item.dataset.pkKey === key;
            item.classList.toggle('is-hit', hit);
            if (hit && item.hasAttribute('data-pk-overflow')) item.hidden = false;
          });
        });
        if (this.idle) this.idle.hidden = Boolean(key);
        if (!this.detail) return;
        if (!key) { this.detail.hidden = true; return; }
        this.detail.hidden = false;
        this.detail.querySelector('[data-pk-detail-name]').textContent = entry.name;
        const purpose = this.detail.querySelector('[data-pk-detail-purpose]');
        purpose.textContent = entry.purpose || '';
        purpose.hidden = !entry.purpose;
        const count = this.detail.querySelector('[data-pk-detail-count]');
        if (count) count.textContent = (this.getAttribute('found-text') || 'Found in [n] formulations').replace('[n]', String(shown));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-page-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-page-nav')) {
    customElements.define('pk-page-nav', class extends HTMLElement {
      connectedCallback() {
        this.links = Array.from(this.querySelectorAll('[data-pk-target]'));
        this.targets = new Map();
        this.links.forEach((link) => {
          const el = document.querySelector('.shopify-section--' + link.dataset.pkTarget);
          if (el) {
            this.targets.set(el, link);
            link.addEventListener('click', (event) => {
              event.preventDefault();
              const offset = this.getBoundingClientRect().height + (parseFloat(getComputedStyle(this).top) || 0) + 8;
              window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
            });
          } else {
            link.parentElement.hidden = true;
          }
        });
        const buy = this.querySelector('[data-pk-buy]');
        if (buy) {
          buy.addEventListener('click', (event) => {
            event.preventDefault();
            const form = document.querySelector('.shopify-section--main-product form[is="product-form"], #shopify-section-main form[is="product-form"], .product-info form');
            const anchor = form || document.querySelector('.shopify-section--main-product, main');
            if (anchor) window.scrollTo({ top: anchor.getBoundingClientRect().top + window.scrollY - 140, behavior: 'smooth' });
          });
        }
        if ('IntersectionObserver' in window && this.targets.size > 0) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.links.forEach((l) => l.removeAttribute('aria-current'));
                const link = this.targets.get(entry.target);
                if (link) {
                  link.setAttribute('aria-current', 'true');
                  const wrap = this.querySelector('.pk-pn__scroll');
                  if (wrap) wrap.scrollTo({ left: Math.max(0, link.offsetLeft - (wrap.clientWidth - link.offsetWidth) / 2), behavior: 'smooth' });
                }
              }
            });
          }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
          this.targets.forEach((link, el) => observer.observe(el));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-review-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-review-wall')) {
    customElements.define('pk-review-wall', class extends HTMLElement {
      connectedCallback() {
        this.cells = Array.from(this.querySelectorAll('.pk-rw__cell'));
        this.filters = this.querySelector('[data-pk-filters]');
        if (!this.filters) return;
        const tags = new Map();
        this.cells.forEach((cell) => {
          const card = cell.querySelector('.pk-rw__card');
          const tag = (card.dataset.tag || '').trim();
          if (!tag) return;
          tags.set(tag, { label: card.dataset.tagLabel || tag, accent: card.style.getPropertyValue('--pk-accent') });
        });
        tags.forEach((info, tag) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pk-chip pk-chip--button pk-chip--sans';
          button.dataset.tag = tag;
          button.setAttribute('aria-pressed', 'false');
          if (info.accent) button.style.setProperty('--pk-accent', info.accent);
          button.textContent = info.label;
          this.filters.appendChild(button);
        });
        this.filters.addEventListener('click', (event) => {
          const button = event.target.closest('[data-tag]');
          if (button) this.filter(button.dataset.tag);
        });
      }

      filter(tag) {
        this.filters.querySelectorAll('[data-tag]').forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.tag === tag ? 'true' : 'false');
        });
        this.cells.forEach((cell) => {
          const card = cell.querySelector('.pk-rw__card');
          cell.hidden = Boolean(tag) && (card.dataset.tag || '') !== tag;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-store-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-store-map')) {
    customElements.define('pk-store-map', class extends HTMLElement {
      connectedCallback() {
        const raw = this.querySelector('[data-pk-stores]');
        try { this.stores = JSON.parse(raw ? raw.textContent : '[]'); } catch (e) { this.stores = []; }
        this.stores = this.stores.filter(s => s && typeof s.lat === 'number' && typeof s.lng === 'number');
        this.stores.forEach((s, i) => { s.id = i; s.hay = ((s.name || '') + ' ' + (s.address || '')).toLowerCase(); });

        this.labels = { retail: 'Markets & retail', convenience: 'Convenience', fitness: 'Gyms & fitness', cafe: 'Cafés & delis', campus: 'Campus & clubs', health: 'Health & wellness', entertainment: 'Entertainment' };
        this.listEl = this.querySelector('[data-pk-list]');
        this.countEl = this.querySelector('[data-pk-count]');
        this.emptyEl = this.querySelector('[data-pk-empty]');
        this.mapEl = this.querySelector('[data-pk-map]');
        this.noteEl = this.querySelector('[data-pk-map-note]');
        this.tpl = this.querySelector('[data-pk-card]');
        this.searchEl = this.querySelector('[data-pk-search]');
        this.nearBtn = this.querySelector('[data-pk-near]');
        this.cat = 'all'; this.q = ''; this.me = null; this.activeId = null; this.markers = new Map();
        this.style.setProperty('--pk-sm-pin', this.dataset.accent || '#FF3B9A');
        this.pendingFit = null;
        if ('ResizeObserver' in window) new ResizeObserver(() => this.onResize()).observe(this.mapEl);

        this.querySelectorAll('[data-pk-chips] [data-cat]').forEach(btn => btn.addEventListener('click', () => {
          this.cat = btn.dataset.cat;
          this.querySelectorAll('[data-pk-chips] [data-cat]').forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
          this.render(true);
        }));
        if (this.searchEl) {
          let t; this.searchEl.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { this.q = this.searchEl.value.trim().toLowerCase(); this.render(true); }, 120); });
        }
        if (this.nearBtn) this.nearBtn.addEventListener('click', () => this.locate());

        this.listEl.addEventListener('click', e => {
          const item = e.target.closest('.pk-sm__item');
          if (!item || e.target.closest('a')) return;
          this.focusStore(Number(item.dataset.id), true);
        });

        this.renderList();
        const start = () => this.initMap();
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver(entries => { if (entries.some(en => en.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: '200px' });
          io.observe(this.mapEl);
        } else { start(); }
      }

      visible() {
        let list = this.stores.filter(s => (this.cat === 'all' || s.category === this.cat) && (!this.q || s.hay.indexOf(this.q) !== -1));
        if (this.me) list = list.slice().sort((a, b) => a.dist - b.dist);
        return list;
      }

      renderList() {
        const list = this.visible();
        this.listEl.innerHTML = '';
        const frag = document.createDocumentFragment();
        list.forEach(s => {
          const node = this.tpl.content.firstElementChild.cloneNode(true);
          node.dataset.id = s.id;
          node.classList.toggle('is-active', s.id === this.activeId);
          node.querySelector('.pk-sm__name').textContent = s.name;
          node.querySelector('.pk-sm__cat').textContent = this.labels[s.category] || '';
          node.querySelector('.pk-sm__addr').textContent = s.address;
          const dist = node.querySelector('.pk-sm__dist');
          if (this.me && typeof s.dist === 'number') { dist.textContent = this.fmtDist(s.dist); dist.hidden = false; }
          const dir = node.querySelector('.pk-sm__dir');
          dir.href = this.directionsUrl(s); dir.textContent = this.dataset.directionsLabel || 'Directions';
          frag.appendChild(node);
        });
        this.listEl.appendChild(frag);
        this.emptyEl.hidden = list.length > 0;
        const tpl = this.dataset.countLabel || '[n] locations';
        this.countEl.textContent = tpl.replace('[n]', list.length).replace(/locations?/, list.length === 1 ? 'location' : 'locations');
        return list;
      }

      render(fit) {
        const list = this.renderList();
        if (!this.map) return;
        if (fit && this.mapEl.clientWidth < 10) { this.pendingFit = list; this.map.show(list, false); return; }
        this.map.show(list, fit);
      }

      onResize() {
        if (!this.map || this.mapEl.clientWidth < 10) return;
        this.map.resize();
        if (this.pendingFit) { const list = this.pendingFit; this.pendingFit = null; this.map.show(list, true); }
      }

      fitList(list) {
        const pts = list.filter(s => typeof s.lat === 'number' && typeof s.lng === 'number');
        if (pts.length < 4) return pts;
        const med = arr => { const a = arr.slice().sort((x, y) => x - y); return a[Math.floor(a.length / 2)]; };
        const c = { lat: med(pts.map(s => s.lat)), lng: med(pts.map(s => s.lng)) };
        const near = pts.filter(s => this.haversine(c, s) < 320);
        return near.length >= 2 ? near : pts;
      }

      directionsUrl(s) { return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(s.address); }
      fmtDist(km) { const mi = km * 0.621371; return (mi < 10 ? mi.toFixed(1) : Math.round(mi)) + ' mi'; }
      haversine(a, b) {
        const R = 6371, dLat = (b.lat - a.lat) * Math.PI / 180, dLng = (b.lng - a.lng) * Math.PI / 180;
        const x = Math.sin(dLat / 2) ** 2 + Math.cos(a.lat * Math.PI / 180) * Math.cos(b.lat * Math.PI / 180) * Math.sin(dLng / 2) ** 2;
        return 2 * R * Math.asin(Math.sqrt(x));
      }

      popupHtml(s) {
        const esc = t => String(t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        return '<div class="pk-sm__popup"><strong>' + esc(s.name) + '</strong><span>' + esc(s.address) + '</span><a href="' + this.directionsUrl(s) + '" target="_blank" rel="noopener">' + esc(this.dataset.directionsLabel || 'Directions') + ' →</a></div>';
      }

      focusStore(id, fromList) {
        const s = this.stores[id]; if (!s) return;
        this.activeId = id;
        this.listEl.querySelectorAll('.pk-sm__item').forEach(li => li.classList.toggle('is-active', Number(li.dataset.id) === id));
        if (this.map) this.map.focus(s);
        if (!fromList) {
          const li = this.listEl.querySelector('.pk-sm__item[data-id="' + id + '"]');
          if (li) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }

      locate() {
        if (!navigator.geolocation) return;
        const label = this.nearBtn.querySelector('[data-pk-near-label]');
        this.nearBtn.setAttribute('aria-busy', 'true'); label.textContent = this.dataset.locatingLabel || 'Locating…';
        navigator.geolocation.getCurrentPosition(pos => {
          this.me = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          this.stores.forEach(s => { s.dist = this.haversine(this.me, s); });
          this.nearBtn.removeAttribute('aria-busy'); label.textContent = this.dataset.nearLabel || 'Near me';
          const list = this.renderList();
          if (this.map) { this.map.showMe(this.me); this.map.show(list.slice(0, 8).concat([this.me]), true); }
        }, () => {
          this.nearBtn.removeAttribute('aria-busy'); label.textContent = this.dataset.nearLabel || 'Near me';
          this.noteEl.textContent = 'We could not read your location. Search by city or zip instead.'; this.noteEl.hidden = false;
        }, { enableHighAccuracy: false, timeout: 9000, maximumAge: 300000 });
      }

      loadScript(src) { return new Promise((res, rej) => { const s = document.createElement('script'); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s); }); }
      loadStyle(href) { return new Promise(res => { if (document.querySelector('link[href="' + href + '"]')) return res(); const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; l.onload = res; l.onerror = res; document.head.appendChild(l); }); }

      async initMap() {
        try {
          if (this.dataset.provider === 'google' && this.dataset.googleKey) await this.initGoogle();
          else await this.initLeaflet();
          this.render(true);
        } catch (e) {
          this.noteEl.textContent = 'The map could not load. The list and directions links still work.'; this.noteEl.hidden = false;
        }
      }

      async initLeaflet() {
        await this.loadStyle('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css');
        if (!window.L) await this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js');
        const L = window.L;
        const map = L.map(this.mapEl, { scrollWheelZoom: false, zoomControl: true, attributionControl: true });
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(map);
        map.setView([33.95, -118.1], 9);
        const icon = (cls) => L.divIcon({ className: 'pk-sm__pin ' + (cls || ''), iconSize: [30, 30], iconAnchor: [15, 15], popupAnchor: [0, -14] });
        const layer = L.layerGroup().addTo(map);
        let meMarker = null, active = null;
        const self = this;
        this.stores.forEach(s => {
          const m = L.marker([s.lat, s.lng], { icon: icon(), title: s.name, keyboard: false });
          m.bindPopup(self.popupHtml(s), { closeButton: false, maxWidth: 260 });
          m.on('click', () => self.focusStore(s.id, false));
          self.markers.set(s.id, m);
        });
        this.map = {
          resize() { map.invalidateSize(); },
          show(list, fit) {
            layer.clearLayers();
            list.forEach(s => { if (s.id !== undefined && self.markers.has(s.id)) layer.addLayer(self.markers.get(s.id)); });
            if (fit && list.length) {
              const pts = self.fitList(list);
              const b = L.latLngBounds(pts.map(s => [s.lat, s.lng]));
              if (pts.length === 1) map.setView(b.getCenter(), 14); else map.fitBounds(b.pad(0.08), { maxZoom: 13 });
            }
          },
          focus(s) {
            if (active) { const el = active.getElement(); if (el) el.classList.remove('pk-sm__pin--active'); }
            const m = self.markers.get(s.id); if (!m) return; active = m;
            if (!layer.hasLayer(m)) layer.addLayer(m);
            const el = m.getElement(); if (el) el.classList.add('pk-sm__pin--active');
            map.flyTo([s.lat, s.lng], Math.max(map.getZoom(), 13), { duration: 0.6 });
            m.openPopup();
          },
          showMe(p) {
            if (meMarker) meMarker.remove();
            meMarker = L.marker([p.lat, p.lng], { icon: icon('pk-sm__pin--me'), title: 'You are here', interactive: false }).addTo(map);
          }
        };
      }

      async initGoogle() {
        const key = this.dataset.googleKey, mapId = this.dataset.googleMapId;
        if (!window.google || !window.google.maps) {
          await new Promise((res, rej) => {
            const cb = '__pkGmaps' + Date.now();
            window[cb] = () => { delete window[cb]; res(); };
            this.loadScript('https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&loading=async&callback=' + cb + (mapId ? '&libraries=marker' : '')).catch(rej);
          });
        }
        const g = window.google.maps;
        const opts = { center: { lat: 33.95, lng: -118.1 }, zoom: 9, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, gestureHandling: 'cooperative', clickableIcons: false };
        if (mapId) opts.mapId = mapId;
        const map = new g.Map(this.mapEl, opts);
        const info = new g.InfoWindow({ maxWidth: 280 });
        const self = this;
        const accent = this.dataset.accent || '#FF3B9A';
        const pinSvg = (scale) => ({ path: g.SymbolPath.CIRCLE, scale: 9 * scale, fillColor: accent, fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 3 });
        let active = null, meMarker = null;
        const useAdvanced = Boolean(mapId && g.marker && g.marker.AdvancedMarkerElement);
        this.stores.forEach(s => {
          let m;
          if (useAdvanced) {
            const el = document.createElement('div'); el.className = 'pk-sm__pin'; el.style.setProperty('--pk-sm-pin', accent);
            m = new g.marker.AdvancedMarkerElement({ position: { lat: s.lat, lng: s.lng }, content: el, title: s.name });
            m.addListener('click', () => self.focusStore(s.id, false));
          } else {
            m = new g.Marker({ position: { lat: s.lat, lng: s.lng }, icon: pinSvg(1), title: s.name });
            m.addListener('click', () => self.focusStore(s.id, false));
          }
          self.markers.set(s.id, m);
        });
        const setMap = (m, on) => { m.map = on ? map : null; if (m.setMap) m.setMap(on ? map : null); };
        const fitTo = (all) => {
          const list = self.fitList(all);
          const b = new g.LatLngBounds(); list.forEach(s => b.extend({ lat: s.lat, lng: s.lng }));
          if (list.length === 1) { map.setCenter(b.getCenter()); map.setZoom(14); } else { map.fitBounds(b, 48); }
        };
        this.map = {
          resize() { g.event.trigger(map, 'resize'); },
          show(list, fit) {
            const keep = new Set(list.map(s => s.id));
            self.markers.forEach((m, id) => setMap(m, keep.has(id)));
            if (fit && list.length) fitTo(list);
          },
          focus(s) {
            const m = self.markers.get(s.id); if (!m) return;
            if (active && !useAdvanced) active.setIcon(pinSvg(1));
            if (active && useAdvanced && active.content) active.content.classList.remove('pk-sm__pin--active');
            active = m; setMap(m, true);
            if (useAdvanced) m.content.classList.add('pk-sm__pin--active'); else m.setIcon(pinSvg(1.35));
            map.panTo({ lat: s.lat, lng: s.lng }); if (map.getZoom() < 13) map.setZoom(13);
            info.setContent(self.popupHtml(s)); info.open({ map, anchor: m });
          },
          showMe(p) {
            if (meMarker) setMap(meMarker, false);
            meMarker = new g.Marker({ position: p, map, icon: { path: g.SymbolPath.CIRCLE, scale: 7, fillColor: '#0d0d0d', fillOpacity: 1, strokeColor: '#ffffff', strokeWeight: 3 }, title: 'You are here', clickable: false });
          }
        };
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-week-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-week-bundle')) {
    customElements.define('pk-week-bundle', class extends HTMLElement {
      connectedCallback() {
        this.addBtn = this.querySelector('[data-pk-add]');
        this.addon = this.querySelector('[data-pk-addon]');
        this.totalEl = this.querySelector('[data-pk-total]');
        this.err = this.querySelector('[data-pk-error]');
        if (this.addon) this.addon.addEventListener('change', () => this.render());
        if (this.addBtn) this.addBtn.addEventListener('click', () => this.add());
        this.render();
      }
      formatMoney(cents) {
        const open = '\\{\\{\\s*', close = '\\s*\\}\\}';
        const tag = (key) => new RegExp(open + key + close);
        const format = this.getAttribute('money-format') || ('$' + '{' + '{amount}' + '}');
        const amount = (cents / 100).toFixed(2);
        const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const whole = Math.round(cents / 100).toString();
        return format
          .replace(tag('amount_no_decimals_with_comma_separator'), whole)
          .replace(tag('amount_with_comma_separator'), amount.replace('.', ','))
          .replace(tag('amount_no_decimals'), whole)
          .replace(tag('amount'), withCommas)
          .replace(/<[^>]*>/g, '');
      }
      render() {
        let total = parseInt(this.dataset.bundlePrice, 10) || 0;
        if (this.addon && this.addon.checked) total += parseInt(this.dataset.addonPrice, 10) || 0;
        if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);
        if (this.err) this.err.hidden = true;
      }
      async add() {
        const items = [{ id: parseInt(this.dataset.bundle, 10), quantity: 1 }];
        if (this.addon && this.addon.checked && this.dataset.addon) items.push({ id: parseInt(this.dataset.addon, 10), quantity: 1 });
        this.addBtn.classList.add('is-loading');
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(body.description || body.message || 'Could not add the pack.');
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') { setTimeout(() => drawer.show(), 400); }
          else { window.location.href = '/cart'; }
        } catch (error) {
          if (this.err) { this.err.textContent = error.message; this.err.hidden = false; }
        } finally {
          this.addBtn.classList.remove('is-loading');
        }
      }
    });
  }
  (function () {
    const bar = document.querySelector('[data-pk-bar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    const target = document.querySelector(bar.dataset.watch);
    const hero = document.querySelector('.pk-week-hero');
    let heroGone = !hero, offerVisible = false;
    const sync = () => bar.classList.toggle('is-on', heroGone && !offerVisible);
    if (hero) new IntersectionObserver((e) => { heroGone = !e[0].isIntersecting; sync(); }, { threshold: 0.05 }).observe(hero);
    if (target) new IntersectionObserver((e) => { offerVisible = e[0].isIntersecting; sync(); }, { threshold: 0.15 }).observe(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-week-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pk-week-add')) {
    customElements.define('pk-week-add', class extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('[data-pk-add]');
        this.err = this.querySelector('[data-pk-error]');
        if (this.btn) this.btn.addEventListener('click', () => this.add());
      }
      async add() {
        const id = parseInt(this.dataset.variant, 10);
        if (!id) return;
        this.btn.classList.add('is-loading');
        if (this.err) this.err.hidden = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          });
          if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(body.description || body.message || 'Could not add to cart.');
          }
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') { setTimeout(() => drawer.show(), 400); }
          else { window.location.href = '/cart'; }
        } catch (error) {
          if (this.err) { this.err.textContent = error.message; this.err.hidden = false; }
        } finally {
          this.btn.classList.remove('is-loading');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
